import React, { useContext, Fragment } from 'react';
import { traverseNodes } from './rericos/render.js';
import { ContentTraverserContext } from 'ricos-context';
import './rericos/renderers/plugins/nodeViewContainer.js';
import 'lodash';
import '../getClassNames-d167519b.js';
import 'classnames';
import './rericos/utils/Anchorable.js';
import './rericos/renderers/plugins/ContainerElement.js';
import 'wix-rich-content-common';
import './rericos/utils/paywallSeo.js';
import 'ricos-schema';
import './components/ErrorBoundary.js';
import './components/Anchor.js';

const RicosNodesRenderer = ({
  nodes,
  isRoot,
  addAnchorsPrefix
}) => {
  const { renderers, nodeViewDecorators } = useContext(ContentTraverserContext);
  const devFallback = void 0;
  const Content = traverseNodes(
    nodes,
    renderers,
    nodeViewDecorators,
    RicosNodesRenderer,
    isRoot,
    addAnchorsPrefix,
    devFallback
  );
  return isRoot ? /* @__PURE__ */ React.createElement("div", { key: "RootedTraversedContent", style: { width: "100%" } }, Content) : /* @__PURE__ */ React.createElement(Fragment, { key: "TraversedContent" }, Content);
};

export { RicosNodesRenderer as default };
//# sourceMappingURL=RicosNodesRenderer.js.map
